import { useRouter } from "next/router";
import { ReactElement, useEffect, useRef } from "react";

import InnerLayout from "../components/innerLayout/InnerLayout";
import { VanityProfile } from "../components/VanityProfile";

const VanityUrlPage = () => {
  const router = useRouter();
  const { vanity } = router.query;
  const hasLoggedInitial = useRef(false);
  const LOG_PREFIX = "[VanityPage]";

  const reservedRoutes = [
    "admin",
    "api",
    "auth",
    "browse",
    "chef",
    "creating-contract",
    "finance",
    "gig",
    "gigs",
    "message",
    "profile",
    "profile-public",
    "user",
    "_app",
    "_document",
    "index",
    "404",
    "500",
  ];

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (!hasLoggedInitial.current) {
      hasLoggedInitial.current = true;
      console.info(LOG_PREFIX, "mount", { path: router.asPath, vanity });
    }

    if (vanity && typeof vanity === "string") {
      if (reservedRoutes.includes(vanity)) {
        console.info(LOG_PREFIX, "reservedRouteRedirect", {
          path: router.asPath,
          vanity,
          target: `/${vanity}`,
        });
        router.replace(`/${vanity}`);
        return;
      }
      console.info(LOG_PREFIX, "vanityRender", { path: router.asPath, vanity });
    }
  }, [vanity, router.asPath, router.isReady, router.replace]);

  if (!router.isReady) {
    return null;
  }

  if (vanity && typeof vanity === "string" && reservedRoutes.includes(vanity)) {
    console.info(LOG_PREFIX, "reservedRouteNull", {
      path: router.asPath,
      vanity,
    });
    return null;
  }

  // For non-reserved routes, render the profile page
  if (vanity && typeof vanity === "string") {
    return <VanityProfile vanity={vanity} />;
  }

  // Handle cases where vanity is not a string (e.g., /?vanity=foo) or other errors
  return null;
};

// Add the getLayout function to ensure proper layout is applied
VanityUrlPage.getLayout = function getLayout(component: ReactElement) {
  return <InnerLayout>{component}</InnerLayout>;
};

export default VanityUrlPage;
